import { useMemo } from "react";

import { useSelector } from "react-redux";

import { useTranslation } from "pro-features/components/WithTranslation";
import {
    ACCOUNTS_MANDATORY_FIELDS,
    CONTACTS_ENRICHMENT_MANDATORY_FIELDS,
} from "app/pages/sales-intelligence/sub-modules/management/constants";
import { selectSfSettings } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforce/exportSelectors";

import CreateJobButton from "../../components/CreateJobButton/CreateJobButton";
import EditExportPreferencesButton from "../../components/EditExportPreferencesButton/EditExportPreferencesButton";
import SectionEmptyState from "../../components/SectionEmptyState/SectionEmptyState";

type Props = {
    isEditDisabled: boolean;
    isCreateJobDisabled: boolean;
    onCreateJob: VoidFunction;
    onEditMapping: VoidFunction;
};

const SalesforceEnrichmentEmptyState = ({ isEditDisabled, isCreateJobDisabled, onCreateJob, onEditMapping }: Props) => {
    const translate = useTranslation();

    const settings = useSelector(selectSfSettings);

    const isMappingDefault: boolean = useMemo(() => {
        const { accounts, leads, contacts } = settings;

        return (
            accounts.filter(({ forEnrichment }) => forEnrichment).length <= ACCOUNTS_MANDATORY_FIELDS.length &&
            leads.filter(({ forEnrichment }) => forEnrichment).length <= ACCOUNTS_MANDATORY_FIELDS.length &&
            contacts.filter(({ forEnrichment }) => forEnrichment).length <= CONTACTS_ENRICHMENT_MANDATORY_FIELDS.length
        );
    }, [settings]);

    return (
        <SectionEmptyState
            iconName="salesforce-cloud-revenue"
            title={translate("si.crm-enrichment.sf.empty-state.title")}
            subtitle={
                isMappingDefault
                    ? translate("si.crm-enrichment.sf.empty-state.subtitle.mapping-default")
                    : translate("si.crm-enrichment.sf.empty-state.subtitle")
            }
        >
            {isMappingDefault ? (
                <EditExportPreferencesButton
                    isDisabled={isEditDisabled}
                    onClick={onEditMapping}
                />
            ) : null}

            <CreateJobButton
                isDisabled={isCreateJobDisabled}
                onClick={onCreateJob}
            />
        </SectionEmptyState>
    );
};

export default SalesforceEnrichmentEmptyState;
